module.exports = __webpack_public_path__ + "media/social-twitter-b8fc1a8a.svg";